module.exports = __webpack_public_path__ + "img/ergoregion-1.013c4d5f.png";